import { render } from "./trialMasterFile.vue?vue&type=template&id=22e73bfc&scoped=true"
import script from "./trialMasterFile.js?vue&type=script&lang=js"
export * from "./trialMasterFile.js?vue&type=script&lang=js"

import "./trialMasterFile.vue?vue&type=style&index=0&id=22e73bfc&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22e73bfc"]])

export default __exports__